import React from 'react';

import cn from 'classnames';

import { omit } from 'lodash';
import { bool, element, oneOfType, string } from 'prop-types';

import MUIIconButton from '@mui/material/IconButton';

import s from './IconButton.css';

/**
 * @param removePadding {bool} - Overrides IconButton's padding and sets it to 0
 */
const IconButton = React.forwardRef(
  ({ children, removePadding, ...restProps }, ref) => (
    <MUIIconButton
      ref={ref}
      disableRipple
      disableTouchRipple
      classes={{
        root: cn(s.root, { [s.noPadding]: removePadding }),
      }}
      {...omit(restProps, ['exact'])}
    >
      {children}
    </MUIIconButton>
  ),
);

IconButton.propTypes = {
  children: oneOfType([element, string]),
  removePadding: bool,
};

IconButton.defaultProps = {
  children: null,
  removePadding: false,
};

export default IconButton;
